const hostname = window.location.hostname;

const LOCALHOST = 'localhost';
const STAGING = 'staging';

const modes = new Map([
  [LOCALHOST, import.meta.env.VITE_API_URL_LOCAL],
  [STAGING, import.meta.env.VITE_API_URL],
]);

export function getBaseUrl() {
  let url = '';
  if (hostname.includes(LOCALHOST)) {
    url = modes.get(LOCALHOST) ?? '';
  } else {
    url = modes.get(STAGING) ?? '';
  }
  return url + '/graphql';
}
